import { render, staticRenderFns } from "./CellRendererActions.vue?vue&type=template&id=133712cb&scoped=true"
import script from "./CellRendererActions.vue?vue&type=script&lang=js"
export * from "./CellRendererActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133712cb",
  null
  
)

export default component.exports